var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.998 2c-.553 0-1 .447-1 1v.6a5 5 0 0 0-4 4.9v.588c0 1.468-.54 2.887-1.516 3.987l-.231.26A.998.998 0 0 0 3.998 15h12a1.002 1.002 0 0 0 .747-1.667l-.232-.259a6 6 0 0 1-1.515-3.987V8.5a5 5 0 0 0-4-4.9V3c0-.553-.447-1-1-1m1.415 15.416A2 2 0 0 0 11.998 16h-4a2 2 0 0 0 .584 1.416A2 2 0 0 0 9.998 18a2 2 0 0 0 1.415-.584"
  })));
};
export default SvgBell;